import { render, staticRenderFns } from "./Aprovar.vue?vue&type=template&id=4a7484cc&scoped=true"
import script from "./Aprovar.vue?vue&type=script&lang=js"
export * from "./Aprovar.vue?vue&type=script&lang=js"
import style0 from "./Aprovar.vue?vue&type=style&index=0&id=4a7484cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7484cc",
  null
  
)

export default component.exports